// src/components/reports/ReportHistoryModal.jsx
import React from 'react';
import { X, Clock, MessageSquare, Flag, CheckCircle } from 'lucide-react';

const ReportHistoryModal = ({ isOpen, onClose, history }) => {
  if (!isOpen || !history) return null;

  const getTimelineIcon = (type) => {
    switch (type) {
      case 'created':
        return Flag;
      case 'moderationNotes':
        return MessageSquare;
      case 'status_change':
        return CheckCircle;
      default:
        return Clock;
    }
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleString();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">Report History</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500">
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="space-y-4">
          {history.timeline.map((item, index) => {
            const Icon = getTimelineIcon(item.type);
            
            return (
              <div key={index} className="flex space-x-4">
                <div className="flex-shrink-0 w-10">
                  <Icon className="h-5 w-5 text-gray-500" />
                </div>
                <div className="flex-grow">
                  <div className="flex justify-between">
                    <p className="text-sm font-medium text-gray-900">
                      {item.type === 'moderationNotes' && 'Moderation note added'}
                      {item.type === 'created' && 'Report created'}
                      {item.type === 'status_change' && `Status changed to ${item.details.status}`}
                    </p>
                    <time className="text-sm text-gray-500">
                      {formatDate(item.timestamp)}
                    </time>
                  </div>
                  <div className="mt-1 text-sm text-gray-600">
                    {item.type === 'moderationNotes' && (
                      <>
                        <p className="font-medium">By {item.details.addedBy.name}</p>
                        <p className="mt-1">{item.details.content}</p>
                      </>
                    )}
                    {item.type === 'created' && (
                      <p>Reason: {item.details.reason}</p>
                    )}
                    {item.type === 'status_change' && (
                      <>
                        <p>Action: {item.details.action}</p>
                        {item.details.notes && (
                          <p className="mt-1">{item.details.notes}</p>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ReportHistoryModal;